import { Component } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-popover',
  templateUrl: 'popover.component.html',
})
export class PopoverComponent {
  projeto = ""
  campanha: string= ""
  local: string =""
  grupos = ""
  metodo = ""
}
